import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import { uuid } from 'uuidv4';
import QRCode from 'qrcode.react';
import { FaQrcode } from 'react-icons/fa';

import { useModal } from '../../../../../../hooks/Modal';

import { useToast } from '../../../../../../hooks/Toast';

import Button from '../../Forms/Button';

import { usePrinter } from '../../../../../../hooks/PrinterHook';
import { userInfo } from 'os';
import { useAuth } from '../../../../../../hooks/Auth';


interface ICreateModule {

    content?: string;
}

export default function QRCodeModule({


    content = ''

}: ICreateModule): JSX.Element {
    const { addModal, removeModal } = useModal();
    const { addToast } = useToast();
    const { addPrint, printIt } = usePrinter();
    const { user } = useAuth();
    const key = uuid();

    const print = line => {
        printIt();
    };

    useEffect(() => {

        if (user) {
            addPrint([
                <div className="qrHolder"
                    style={{
                        padding: '20px 5px',
                        background: '#fff',
                        width: '100%',
                        textAlign: 'center',

                    }}
                > <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center', width: '100%'
                }}> <img src="/apoio/logo.png" style={{ width: '250px' }} />   <QRCode style={{ marginTop: '20px' }}

                    size={100}
                    includeMargin={true}
                    imageSettings={{ src: "", width: 100, height: 100, excavate: false }}
                    renderAs="svg"
                    value={user.user_hash}
                        /></div>
                    <div style={{ marginTop: '20px', padding: '20px', textAlign: 'center', color: '#333' }} dangerouslySetInnerHTML={{ __html: content }} />





                </div>]
            );
        }

    }, [user])

    const handleQR = (line) => {

        const contentValue = <><h2>QRCode</h2><div className="qrHolder" style={{ padding: '20px', background: '#fff' }}><QRCode
            renderAs="svg"

            size={300}
            includeMargin={true}
            value={
                line.student && line.user_hash
                    ? line.user_hash
                    : line.user_hash
            }
        /></div> <Button onClick={() => print(line)}>Imprimir</Button></>;

        return contentValue;
    };

    const moduleQRCode = (): JSX.Element =>
        handleQR(user)
        ;

    return moduleQRCode();
}
